if (!customElements.get("sizeguide-toggle")) {
  class SizeguideToggle extends HTMLElement {
    constructor() {
      super();

      this.isInitialized = false;
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      document.dispatchEvent(new CustomEvent("sizeguide:toggle"));
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.addEventListener("click", this.handleClick.bind(this));

      this.isInitialized = true;
    }
  }

  customElements.define("sizeguide-toggle", SizeguideToggle);
}
